@if (variant === 'inline') {
    <div class="flex items-center gap-2 text-xs text-gray-600 truncate">
        @if (tenantLabel(); as t) {
            <span class="truncate font-semibold text-gray-800">{{ t }}</span>
        }
        @if (empresaLabel(); as e) {
            <span class="text-gray-400">·</span>
            <span class="truncate">{{ e }}</span>
        }
        @if (sucursalLabel(); as s) {
            <span class="text-gray-400">·</span>
            <span class="truncate">{{ s }}</span>
        }
    </div>
} @else {
    <div class="rounded-lg border border-gray-200 bg-gray-50 px-4 py-3 text-xs text-gray-700 space-y-1.5">
        <!-- Consorcio -->
        @if (tenantLabel(); as t) {
            <div class="flex items-center gap-2 truncate">
                <span class="shrink-0 text-gray-400">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-3.5 w-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 21h16.5M4.5 3h15M5.25 3v18m13.5-18v18M9 6.75h1.5m-1.5 3h1.5m-1.5 3h1.5m3-6H15m-1.5 3H15m-1.5 3H15M9 21v-3.375c0-.621.504-1.125 1.125-1.125h3.75c.621 0 1.125.504 1.125 1.125V21" />
                    </svg>
                </span>
                <span class="truncate font-semibold text-gray-800">{{ t }}</span>
            </div>
        }

        <!-- Empresa activa -->
        <div class="flex items-center gap-2">
            <span class="shrink-0 text-gray-400">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-3.5 w-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 21h19.5m-18-18v18m10.5-18v18m6-13.5V21M6.75 6.75h.75m-.75 3h.75m-.75 3h.75m3-6h.75m-.75 3h.75m-.75 3h.75M6.75 21v-3.375c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21" />
                </svg>
            </span>
            @if (currentEmpresa(); as empresa) {
                <span class="truncate">{{ empresa.razonSocial }}</span>
                <span class="ml-auto shrink-0 font-mono text-gray-400">{{ empresa.rfc }}</span>
            } @else {
                <span class="italic text-gray-400">Empresa pendiente</span>
            }
        </div>

        <!-- Sucursal activa -->
        <div class="flex items-center gap-2">
            <span class="shrink-0 text-gray-400">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-3.5 w-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                    <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0Z" />
                </svg>
            </span>
            @if (currentSucursal(); as suc) {
                <span class="truncate">{{ suc.nombre }}</span>
                @if (suc.esMatriz) {
                    <span class="ml-1 shrink-0 rounded bg-indigo-100 px-1 py-0.5 text-[10px] font-medium text-indigo-700">Matriz</span>
                }
            } @else {
                <span class="italic text-gray-400">Sucursal pendiente</span>
            }
        </div>
    </div>
}